module.exports = __webpack_public_path__ + "img/3dayblinds_logo.b3c87456.svg";